import { render, staticRenderFns } from "./responder-fale-com-a-gente.vue?vue&type=template&id=c8ca22a0&"
import script from "./responder-fale-com-a-gente.vue?vue&type=script&lang=ts&"
export * from "./responder-fale-com-a-gente.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8ca22a0')) {
      api.createRecord('c8ca22a0', component.options)
    } else {
      api.reload('c8ca22a0', component.options)
    }
    module.hot.accept("./responder-fale-com-a-gente.vue?vue&type=template&id=c8ca22a0&", function () {
      api.rerender('c8ca22a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fale-com-a-gente/responder-fale-com-a-gente.vue"
export default component.exports